module.exports = {
	maxDateRange: 31,
};
